import { words, startCase, lowerCase } from 'lodash';

const startCaseText = string => startCase(lowerCase(string));

const shortName = (name) => {
  const names = words(name);
  if (names.length > 1) {
    return startCaseText(`${names[0]} ${names[names.length - 1]}`);
  }
  return names[0];
};


export default shortName;



// WEBPACK FOOTER //
// ./src/utils/short-name.js